import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import TopicHeader from "../TopBar/TopicHeader"
import TypeArea from "../bottomBar/TypeArea"
import { SyncLoader } from "react-spinners";
import MessagesBody from "./MessagesBody";
import { Context } from "./ChatContext";
import { IMessage, ITopic } from "../../types";
import { useAtomInstance, useAtomSelector, useAtomValue } from "@zedux/react";
import { isActiveTopicIsLoadingSelector } from "../../atoms/atoms";
import { messageReceiverAtom } from '../../atoms/messageReceiverAtom';
import { messagesAtomFamily } from '../../atoms/messagesAtomFamily';
import JDate from "jalali-date"
import { selectedFilterAtom } from "@src/atoms/filterAtoms";
import { convert_to_fa } from "@src/functions/farsi";
import { typeAreaAtom } from "@src/atoms/typeAreaAtoms";
import GIcon from "../GIcon";
import ArrowIcon2 from "@src/icons/ArrowIcon2";
import { ScrollToBottom } from "./ScrollToBottom";


const Loading = () => {
    return <div className='flex flex-row justify-center mt-auto mb-4 w-full'>
        <SyncLoader color="#cbd5e1" />
    </div>

}

const SHOW_SCROLL_TO_BOTTOM_THRESHOLD = 100; // Threshold in pixels to show the scroll-to-bottom button
const FETCH_NEXT_MESSAGES_THRESHOLD = 100; // Threshold in pixels to fetch next messages when scrolling up


export default function Messages({ topic_id, topic }: { topic_id: number, topic: ITopic }) {
    const { context, helpMode = false } = useContext(Context)

    const messagesListRef = useRef<HTMLDivElement>(null)
    const isLoading = useAtomSelector(isActiveTopicIsLoadingSelector, context)

    const filter = useAtomValue(selectedFilterAtom, [context, topic_id])
    const messages = useAtomValue(messagesAtomFamily, [topic_id, filter, context])
    const messagesReversed = useMemo(() => {
        if (Array.isArray(messages)) {
            return [...messages].reverse()
        }
        return []
    }, [messages])

    const { fetchMessages } = useAtomInstance(messageReceiverAtom, [context]).exports
    // const [largestMessageIdScrolled, setLargestMessageIdScrolled] = useState<number | null>(null)
    const [targetScrollId, setTargetScrollId] = useState<number | null>(null)
    const [highlight, setHighlight] = useState<number | null>(null)
    const [showScrollToBottom, setShowScrollToBottom] = useState(false)

    // const largestMessageId = Array.isArray(messages) && messages.length > 0 ? messages[messages.length - 1].message_id : null

    const handleScrollToBottom = () => {
        if (messagesListRef.current) {
            messagesListRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    // useEffect(() => {
    //     if (largestMessageId !== null && (largestMessageIdScrolled === null || largestMessageId > largestMessageIdScrolled)) {
    //         setLargestMessageIdScrolled(largestMessageId)

    //         // Scroll to the end
    //         // setTimeout(() => {
    //         //     requestAnimationFrame(() => {
    //         //         if (messagesListRef.current) {
    //         //             messagesListRef.current.scrollTo({ left: 0, top: messagesListRef.current.scrollHeight, behavior: "smooth" })
    //         //         }
    //         //     })
    //         // }, 50);
    //     }
    // }, [largestMessageId])

    useEffect(() => {
        if (targetScrollId) {
            setTimeout(() => {
                requestAnimationFrame(() => {
                    if (performScroll(targetScrollId)) {
                        setTargetScrollId(null);
                    }
                })
            }, 2000);
        }
    }, [messages, targetScrollId]);


    // const [editMode, setEditMode] = useState<IMessage | null>(null)
    // const [replyMode, setReplyMode] = useState<IMessage | null>(null)
    const { setEditMode, setReplyMode } = useAtomInstance(typeAreaAtom, [context, topic_id]).exports


    // const [messages2, setFilteredMessages] = useState<IMessage[]>([])
    // const mesageIds = useRef<Set<number>>(new Set())

    // console.log("render messages", { messages, topic_id })

    // const [lastMessageId, setLastMessageId] = useState(-1)

    // useEffect(() => {
    //     let filtered_messages = getVisibleMessages(topic_id, filter, { messages: { [topic_id]: { ...messages[topic_id] } }, errorMessages: {}, pendingMessages: {} })

    //     setFilteredMessages([...filtered_messages])
    // }, [messages, filter, topic_id])

    const performScroll = (id: number) => {
        const targetId = topic_id + "-" + id + "-message"
        console.log('perform scroll', targetId)

        const elem: HTMLElement | null = document.getElementById(targetId);
        if (!elem) {
            return false;
        }

        // let initClassName = elem.className;
        // elem.className = initClassName + " bg-sky-500/60"
        // setTimeout(() => {
        //     const currentClasses = elem.className.split(" ");
        //     elem.className = currentClasses.filter(c => c !== "bg-sky-500/60").join(" ") + " hide-bg";
        // }, 3000)
        elem.scrollIntoView({ behavior: 'smooth', block: 'end' })
        setHighlight(id)
        setTimeout(() => {
            setHighlight(null)
        }, 2500)
        return true
    }

    const handleScroll = async (id: number) => {
        if (!performScroll(id)) {
            setTargetScrollId(id);
            // Note : we check id existence before loading, so we don't fetch again if message is already loaded
            await fetchMessages(topic_id, { upto: id, filter });
        }
    }
    // useEffect(() => {
    //     mesageIds.current.clear()
    // }, [])

    // useEffect(() => {
    //     if (messagesListRef.current) {
    //         if (messages.length != 0 && lastMessageId != -1) {
    //             // messagsBodyRef.current.scrollTo({ left: 0, top: , behavior: "instant" }) TODO
    //             // setTopScroll(messagsBodyRef.current.scrollHeight - messagsBodyRef.current.scrollTop)
    //         } else {
    //             messagesListRef.current.scrollTo({ left: 0, top: messagesListRef.current.scrollHeight, behavior: "instant" }) // scroll to bottom debugger
    //         }
    //         if (messages[messages.length - 1]) {
    //             setLastMessageId(messages[messages.length - 1].message_id)
    //         }
    //     }
    // }, [messagesListRef, messagesListRef.current, messages])

    return <div className="relative flex flex-col gap-2 transition-[background-color] duration-3000 grow make-bottom-tab-hide">
        {(topic && topic_id != -1) ? <TopicHeader topic={topic} /> : null}
        <div

            onScroll={async (e: React.UIEvent<HTMLElement>): Promise<void> => {
                const target = e.target! as HTMLDivElement
                // console.log('st', target.scrollTop, 'ch', target.clientHeight, 'sh', target.scrollHeight)
                // console.log('left', -target.scrollTop , 'right', target.scrollHeight - target.clientHeight - 100)

                // Update visibility of scroll to bottom button
                // In flex-col-reverse, scrollTop is 0 at the bottom and negative as we scroll up
                if (-target.scrollTop > SHOW_SCROLL_TO_BOTTOM_THRESHOLD) {
                    setShowScrollToBottom(true)
                } else {
                    setShowScrollToBottom(false)
                }

                if ((target.scrollHeight > target.clientHeight) &&
                    (-target.scrollTop > target.scrollHeight - target.clientHeight - FETCH_NEXT_MESSAGES_THRESHOLD)
                ) {
                    await fetchMessages(topic_id, { filter })
                }
            }}

            onScrollEnd={(e: React.UIEvent<HTMLElement>): void => {
                const target = e.target! as HTMLDivElement
                // console.log('scrollEnd', target.scrollTop, target.scrollHeight, target.clientHeight)
                if (target.scrollTop > 0) {
                    target.scrollTop = 0
                }
            }}

            ref={messagesListRef}
            className='relative flex flex-col-reverse gap-2 bg-chat bg-white px-6 pb-6 h-0 overflow-y-auto text-[0.8em] grow overscroll-none'>
            {
                messagesReversed.map((m, i) => {
                    const lastIndex = messagesReversed.length - 1

                    const dateFormatted = formatDate(parseInt(m.created_at.toString()))
                    const lastMessageFormatted = i < lastIndex ? formatDate(parseInt(messagesReversed[i + 1].created_at.toString())) : null
                    const dayPassed = lastMessageFormatted != null && dateFormatted != lastMessageFormatted
                    const showName = (i == lastIndex) || (i < lastIndex && m.sender_username != messagesReversed[i + 1].sender_username) || (dayPassed)
                    return (
                        <React.Fragment key={m.message_id}>
                            <MessagesBody
                                topic={topic}
                                showName={showName}
                                replyClicked={handleScroll}
                                key={m.message_id}
                                message={m}
                                setEditMode={setEditMode}
                                setReplyMode={setReplyMode}
                                highlight={highlight === m.message_id}
                            />
                            {Boolean(i == lastIndex || dayPassed) &&
                                <div className="empty:hidden self-center p-2 rounded-xl w-fit text-center" key={`date-${i}`}>
                                    {convert_to_fa(dateFormatted)}
                                </div>
                            }


                        </React.Fragment>
                    )
                })
            }
            {(isLoading && topic_id != -1) && <Loading />}

            <ScrollToBottom onClick={handleScrollToBottom} visible={showScrollToBottom} />
        </div>


        <TypeArea
            topic={topic}
            disabled={!topic}
        />

        {/* {(topic_id != -1) && <GIcon
            onClick={() => messagsBodyRef.current?.scrollTo({ left: 0, top: 0 })}
            onContextMenu={e => e.persist()} name="arrow_downward" className="bottom-0 absolute justify-items-end self-end hover:bg-sky-400 mt-auto p-2 border-2 border-blue-700 rounded-full hover:text-white cursor-pointer" />} */}



    </div >
}

function formatDate(created_at: number) {
    const dateJalali = new JDate(new Date(created_at))
    return dateJalali.format("dddd DD MMMM YYYY")
}

/**
 * {(activeTopicID != -1) && <GIcon
            style={{
                marginBottom: 100,
                marginLeft: 20,
            }}
            onClick={() => messagsBodyRef.current?.scrollTo({ left: 0, top: 0 })}
            onContextMenu={e => e.persist()} name="arrow_upward" className="bottom-0 absolute justify-items-end self-end hover:bg-sky-400 mt-auto p-2 border-2 border-blue-700 rounded-full hover:text-white cursor-pointer" />}
 */

